import * as React from 'react'

import useReadAloudPlayer, { PlayerChunk } from './useReadAloudPlayer'

import { PLAYER_STATUS } from '../../components/readAloud/constants'
import { useReadAloud } from '../../components/readAloud/readAloudContext'
import { ReadAloudSpeakerToggle } from '../../components/readAloud/readAloudSpeakerToggle'

interface ChunkedReadAloudOptions {
  chunks: PlayerChunk[];
  focusOnDark?: boolean;
  label: string;
}

const useChunkedReadAloud = ({ chunks, focusOnDark, label, }: ChunkedReadAloudOptions) => {
  const { readAloudEnabled, } = useReadAloud()
  const playerChunks = React.useMemo(() => (readAloudEnabled ? chunks : []), [readAloudEnabled, chunks])
  const { activeChunkIndex, activeWordIndex, play, playRequested, status, stop, } = useReadAloudPlayer({ chunks: playerChunks, })
  const playing = status === PLAYER_STATUS.PLAYING || playRequested

  const chunkProps = (index: number) => ({ html: chunks[index].html, spokenWordIndex: activeChunkIndex === index ? activeWordIndex : null, })
  const speaker = readAloudEnabled && chunks.length > 0
    ? <ReadAloudSpeakerToggle focusOnDark={focusOnDark} label={label} onPlay={play} onStop={stop} playing={playing} />
    : null

  return { activeChunkIndex, activeWordIndex, chunkProps, play, playing, readAloudEnabled, speaker, stop, }
}

export default useChunkedReadAloud
